module.exports = __webpack_public_path__ + "static/img/wallet_icon.bdb092d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wallet_icon.png
// module id = gFyi
// module chunks = 56